// responsive.service.ts
import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, computed, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  private breakpointObserver = inject(BreakpointObserver);

  // Signal for handset (e.g., phones)
  private isHandsetSignal = signal(false);

  // Signal for tablets
  private isTabletSignal = signal(false);

  constructor() {
    this.breakpointObserver.observe(['(max-width: 767px)']).subscribe(result => this.isHandsetSignal.set(result.matches));

    this.breakpointObserver.observe(['(max-width: 1024px) and (min-width: 768px)']).subscribe(result => this.isTabletSignal.set(result.matches));
  }

  // Expose signal
  isHandset = computed(() => this.isHandsetSignal());

  isTablet = computed(() => this.isTabletSignal());
}
